import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "id", "className", "visuallyHidden"];
import TrackedLink from '../../TrackedLink';
import useMenuItem from '../hooks/useMenuItem';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledLink = styled(TrackedLink).withConfig({
  displayName: "MenuItem__StyledLink",
  componentId: "sc-1xpfomg-0"
})(["display:block;"]);
export const MenuItem = _ref => {
  let {
      children,
      id,
      className,
      visuallyHidden
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    menuItemId,
    setRef,
    onMenuItemKeyDown,
    tabIndex
  } = useMenuItem({
    visuallyHidden,
    id
  });
  return /*#__PURE__*/_jsx("li", {
    role: "menuitem",
    className: className,
    children: /*#__PURE__*/_jsx(StyledLink, Object.assign({
      id: menuItemId,
      ref: setRef,
      onKeyDown: onMenuItemKeyDown,
      tabIndex: tabIndex
    }, rest, {
      children: children
    }))
  });
};
export default MenuItem;